import { Link } from "react-router-dom";
import type { Currency, Participant, Receipt } from "@/api/types";
import { CurrencyBadge } from "./CurrencyBadge";
import { MoneyAmount } from "./MoneyAmount";
import { ReceiptStatusBadge } from "./ReceiptStatusBadge";
import { RelativeTime } from "./RelativeTime";
import { receiptTitle } from "@/utils/receipt";
import { participantLabel } from "@/utils/avatar";
import "./receipt-card.css";

export interface ReceiptCardProps {
  tripSlug: string;
  receipt: Receipt;
  paidBy?: Participant;
}

const PARSING_OR_PENDING: Receipt["status"][] = ["parsing", "pending_upload", "parse_failed"];

export function ReceiptCard({ tripSlug, receipt, paidBy }: ReceiptCardProps) {
  const title = receiptTitle(receipt);
  const showMeta = !PARSING_OR_PENDING.includes(receipt.status);
  const ccy: Currency | undefined = receipt.source_ccy ?? undefined;

  return (
    <li className="wp-rcpt">
      <Link
        to={`/t/${tripSlug}/receipts/${receipt.receipt_id}`}
        className="wp-rcpt__link"
        data-testid="receipt-card"
      >
        <div className="wp-rcpt__row">
          <ReceiptStatusBadge status={receipt.status} source={receipt.source} />
          <span className="wp-rcpt__title">{title}</span>
          <CurrencyBadge ccy={receipt.source_ccy} />
        </div>
        <div className="wp-rcpt__row wp-rcpt__row--balanced">
          <span className="wp-rcpt__paid-by">
            {paidBy ? `${participantLabel(paidBy)} сплатив(ла)` : "Платник не вказаний"}
          </span>
          {receipt.source_total != null && ccy ? (
            <MoneyAmount value={receipt.source_total} ccy={ccy} size="body" />
          ) : null}
        </div>
        {showMeta ? (
          <div className="wp-rcpt__meta">
            <RelativeTime value={receipt.updated_at} prefix="оновлено" />
          </div>
        ) : null}
      </Link>
    </li>
  );
}
